<div>
  <button [id]="instanceId" class="btn btn-primary" (click)="openReactiveCodeEditor()" [disabled]="disabled">
    <i class="fa fa-code"></i> Open Code Editor
  </button>
</div>
